<template>
  <div class='main-title container-xl container-fluid pb-5 mtp-36'>
    <div v-if="this.$store.state.userData.last_au && this.$store.state.userData.last_au.paypassword_need != 0" class='content confirm-pass p24 d-flex justify-content-between mbp-20' :class="this.$store.state.resize.w <= 990 ? 'flex-column align-items-start' : 'align-items-center' ">
      <span class="neue text-black" :class="this.$store.state.resize.w <= 990 && 'mbp-20'">{{ $t('views.Home.14') }}</span>
      <router-link to="safety/pay_pass">
        <Button 
          @mouseover="iconHover = 'lock-open'"
          @mouseleave="iconHover = false" 
          type="btn-outline-grey"
        >
          <Icon :name="'lock-open'" class="c20 mr10 ml16" :active="iconHover === 'lock-open'" />
          <span class="mr16 neue">{{ $t('views.Home.24') }}</span>
        </Button>
      </router-link>
    </div>
    <div v-if="showKycBanner" class='kyc-banner d-flex justify-content-between mbp-20' :class="this.$store.state.resize.w <= 990 ? 'flex-column align-items-start' : 'align-items-center' ">
      <span class="neue kyc-banner__text" :class="this.$store.state.resize.w <= 990 && 'mbp-20'">{{ $t('views.Home.59') }}</span>
      <router-link to="/kyc">
        <button class="kyc-banner__btn neue">
          <Icon :name="'shield-check'" class="c20 mr8" :active="false" />
          <span>{{ $t('views.Home.60') }}</span>
        </button>
      </router-link>
    </div>
    <div class="d-flex align-items-center justify-content-between mb24">
      <h4 class="fw-normal neue text-black m-0" :class="{ 'fsp20': this.$store.state.resize.w <= 500, 'fsp28 lh-base': this.$store.state.resize.w > 500 }">{{ $t('views.Home.38') }}</h4>
      <Button 
        @click='createKeytModal' type='btn-outline-warning'
        @mouseover="iconHover = 'plus'"
        @mouseleave="iconHover = false" 
        class="create-btn ml12 neue" 
        :class="{ 'py14 px24': this.$store.state.resize.w > 500, 'py10 px16': this.$store.state.resize.w <= 500 }" 
      >
        <Icon name="plus" :size="'c20'" :active="iconHover === 'plus'" />
        <span v-if="this.$store.state.resize.w <= 500" class="ml8 fsp14 fw-normal text-menu-bg text-nowrap">{{ this.$t('views.Home.37') }}</span>
        <span v-else class="ml8 fsp14 fw-normal text-menu-bg text-nowrap">{{ this.$t('views.Home.36') }}</span>
      </Button>
    </div>
    <div class='p-0 gap24 align-items-stretch justify-content-between mb24' 
      :class="this.$store.state.resize.w <= 768 ? 'd-block content' : 'd-flex'"
    >
      <div v-if="this.$store.state.resize.w <= 768" class="d-flex justify-content-center pt16 px16 mb8">
        <CustomSelectButton
          v-model:modelValue="dashboard_block"
          :options="[{ label: $t('views.Home.1'), value: 'passport' }, { label: this.stage_title[this.of_stage], value: 'currs' }]" 
        />
      </div>
      <div v-if="this.$store.state.resize.w > 768 || this.dashboard_block === 'passport'" class="flex-grow-1 neue" :class="{ 'w-50 fsp16': this.$store.state.resize.w > 768, 'fsp14': this.$store.state.resize.w <= 768}">
        <div class='height_fix d-flex flex-column text-black mb-0' v-if="this.$store.state.userData.passport_serial" :class="{ 'content h-100': this.$store.state.resize.w > 768 }">
          <div v-if="this.$store.state.resize.w > 768" class="d-flex align-items-center justify-content-between px24 pt24 mb8 lh28">
            <div class="mw-0 d-flex align-items-center">
              <Icon :name="'user'" :color="{ 0: '#000000', 1: '#000000' }" />
              <h4 class='text-black mb-0 neue fsp20 ml12 text-nowrap text-truncate fw-medium'>{{ $t('views.Home.1') }}</h4>
            </div>
            <router-link :to="{ name: 'Corr_info', query: { uid: this.$store.state.userData.id } }" class="menu-bg ml20 fsp14">{{ $t('views.Home.2') }}</router-link>
          </div>
          <div class="d-flex flex-column flex-grow-1" :class="this.$store.state.resize.w <= 768 ? 'p16': 'p24'">
            <div>
              <div v-if="this.$store.state.userData.user_info?.email?.value" class='d-flex p-0 g-3 align-items-center justify-content-between border-b pb16 w-100'>
                <span class='d-flex align-items-center'>
                  <IconC v-if="this.$store.state.resize.w > 768" :name="'mail'" class="mr12 c20" />
                  <span class="opacity-50 neue-roman">{{ $t('views.Home.39') }}</span>
                </span> 
                <span class='neue d-flex flex-row align-items-center pl-1 text-start cli_2'>
                  {{ this.$store.state.userData.user_info.email.value }}
                  <Icon :name="'copy'" class="ml4 pointer" :class="this.$store.state.resize.w <= 768 ? 'c16': 'c20'" @click.stop="copy(this.$store.state.userData.user_info.email.value)" />
                  <input type='hidden' id='cli_h1' :value="this.$store.state.userData.user_info.email.value"/>
                </span>  
              </div>
              <div v-if="this.$store.state.userData.user_info?.mobile?.value" class='d-flex py16 g-3 align-items-center justify-content-between border-b pbp-16 w-100'>
                <span class='d-flex'>
                  <IconC v-if="this.$store.state.resize.w > 768" :name="'phone'" class="mr12 c20" />
                  <span class="opacity-50 neue-roman">{{ $t('views.Home.40') }}</span>
                </span> 
                <span class='neue d-flex flex-row align-items-center pl-1 text-start cli_2'>  
                  {{ this.$store.state.userData.user_info.mobile.value }}
                  <Icon :name="'copy'" class="ml4 pointer" :class="this.$store.state.resize.w <= 768 ? 'c16': 'c20'" @click.stop="copy(this.$store.state.userData.user_info.mobile.value)" />
                  <input type='hidden' id='cli_h1' :value="this.$store.state.userData.user_info.mobile.value"/>
                </span>  
              </div>
            </div>
            <div class='d-flex p-0 g-3 align-items-center justify-content-between border-b py16'>
              <span class='opacity-50 d-flex align-items-center'>
                <IconC v-if="this.$store.state.resize.w > 768" :name="'user'" :color="{ 0: '#000000', 1: '#000000' }" class="mr12 c20" />
                <span class=" neue-roman">{{ $t('views.Home.3') }}</span>
              </span> 
              <span class='neue d-flex flex-row align-items-center pl-1 text-start'>
                <span class="fw-medium">{{ this.$store.state.userData.id }}</span>
                <Icon :name="'copy'" class="ml4 pointer" :class="this.$store.state.resize.w <= 768 ? 'c16': 'c20'" @click.stop="copy(this.$store.state.userData.id)" />
                <input type='hidden' id='cli_h1' :value="this.$store.state.userData.id"/>
              </span>  
            </div>
            <div class='d-flex p-0 g-3 align-items-center justify-content-between border-b pyp-16'>
              <span class='d-flex align-items-center'>
                <IconC v-if="this.$store.state.resize.w > 768" :name="'calendar'" class="mr12 c20" />
                <span class="opacity-50 neue-roman">{{ this.$store.state.resize.w > 1280 ? $t('views.Home.4') : $t('views.Home.56') }}</span>
              </span>
              <span class='pl-1 text-start'>{{ this.$store.state.userData.pass.date_reg }}</span>  
            </div>
            <div v-if="this.$store.state.userData.last_au.last_autorization_date" class='d-flex align-items-center p-0 g-3 justify-content-between py16 border-b'>
              <span class='d-flex align-items-center'>
                <IconC v-if="this.$store.state.resize.w > 768" :name="'clock'" class="mr12 c20" />
                <span class="opacity-50 lh-1 neue-roman">{{ $t('views.Home.5') }} </span>
              </span> 
                <span class='pl-1 text-start lh-1 fw-medium text-end text-nowrap'>
                  {{ this.$lib.formateDate(this.$store.state.userData.last_au.last_autorization_date) }}
                </span>
            </div>
            <div class='d-flex p-0 g-3 justify-content-between pt16'>
              <span class='d-flex align-items-center'>
                <IconC v-if="this.$store.state.resize.w > 768" :name="'globe'" class="mr12 c20" />
                <span class="opacity-50 neue-roman">{{ this.$store.state.resize.w > 768 ? $t('views.Home.43') : $t('views.Home.6') }}</span>
              </span>
              <span class="break-all d-flex fw-medium align-items-center">
                {{ this.$store.state.userData.last_au.last_autorization_ip }}
                <Icon :name="'copy'" class="ml4 pointer" :class="this.$store.state.resize.w <= 768 ? 'c16': 'c20'" @click.stop="copy(this.$store.state.userData.last_au.last_autorization_ip)" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.$store.state.resize.w > 768 || this.dashboard_block === 'currs'" class="flex-grow-1" :class="{ 'w-50': this.$store.state.resize.w > 768}">
        <PortfolioCard
          :selectedCurr="this.selected_curr"
          :selectedCurrKey="this.selected_curr_key"
          :currKeywords="this.currs_keywords"
          :overallBalance="this.overall_balance"
          :rate="this.rate"
          @updateState="this.updateState"
          @paySelect="this.paySelect"
          @createKeyt="this.createKeytModal"
        />
      </div>
    </div>
    <KeytsTable v-if="keytsLoaded" :data="this.keyts" class="mb-3" :of_stage="this.of_stage" @updateStage="this.changeStage"/>
    <!-- own: скелетон строк счетов при первой загрузке дашборда, пока кошельки ещё не пришли -->
    <div v-else class="bg-white rounded12 overflow-hidden mb-3">
      <div v-for="n in 4" :key="'sk-home-keyt-' + n"
        class="d-flex align-items-center border-b"
        :class="{ 'p16': displaySize <= 768, 'px24 py12': displaySize > 768 }"
      >
        <SkeletonBlock width="40px" height="40px" border-radius="50%" />
        <div class="ml16 flex-grow-1">
          <SkeletonBlock width="160px" height="14px" />
          <div class="mt8"><SkeletonBlock width="90px" height="12px" /></div>
        </div>
        <div v-if="displaySize > 768" class="d-flex flex-column align-items-end mr24">
          <SkeletonBlock width="80px" height="14px" />
          <div class="mt8"><SkeletonBlock width="60px" height="12px" /></div>
        </div>
        <div class="d-flex gap-2">
          <SkeletonBlock width="40px" height="40px" border-radius="8px" />
          <SkeletonBlock width="40px" height="40px" border-radius="8px" />
          <SkeletonBlock v-if="displaySize > 768" width="40px" height="40px" border-radius="8px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import Title from '@/components/service/Title';
import Button from '@/components/service/Button.vue';
import Icon from '@/components/icons/Icon.vue';
import CustomLoader from '@/components/service/CustomLoader';
import KeytsTable from '@/components/service/keyts/KeytsTable.vue';
import SelectSimple from '@/components/service/SelectSimple';
import IconC from "@/components/icons/Icon.vue";
import CustomSelectButton from '@/components/service/CustomSelectButton.vue';
import PortfolioCard from '@/components/service/dashboard/PortfolioCard.vue';
import SkeletonBlock from '@/components/service/SkeletonBlock';
import Popper from '@/components/service/Popper.vue';

export default {
  components: {
    Title,
    Button,
    Icon,
    CustomLoader,
    KeytsTable,
    SelectSimple,
    IconC,
    CustomSelectButton,
    Popper,
    PortfolioCard,
    SkeletonBlock
  },
  data() {
    return {
      str: 'test',
      str2: 'arrow',
      str3: 'key',
      templates: [],
      of_stage: 0,
      stage_title: {
        0: this.$t('views.Home.30'),
        1: this.$t('views.Home.34'),
        2: this.$t('views.Home.32')
      },
      pays: [],
      news: [],
      ready: false,
      keyts: [],
      currs: false,
      selected_curr: false,
      selected_curr_key: false,
      keyts_length: false,
      templates_length: false,
      storage_key: 'preferred curr',
      btns_text: {},
      dashboard_block: 'passport',
      overall_balance: false,
      rate: false,
      iconHover: false,
      currs_keywords: [],
      showKycBanner: false,
      kycChecked: false,
    }
  },
  created() {
    this.$store.commit('TITLE', 'HomePage');
    // if (this.$store.state.config.KEYTS_RATE_CURR) {
    //   this.axios.post('GetListRates', {data: {curr_src: this.$store.state.config.KEYTS_RATE_CURR}}).then(res => {
        
    //   });
    // }

    // console.log('store this.$store.state home page', this.$store.state);
    // console.log('this.$store.atmIncassRest home page', this.$store.state.atmIncassRest);
  },
  mounted() {
    // this.keyts = this.getKeyts();
    // console.log(this.keyts)
    // this.getTemplates();
    // DELTA: disabled
    // this.axios.post('Init', {no_loader: true}).then(res => {
    //   // this.pays = res.data.body[0] || [];
    //   this.news = res.data.body[1] || [];
    //   this.ready = true;
    // });
    this.getOverallBalance()
  },
  computed: {
    t () {
      let k = this.$store.getters.get_sort_keyts;
      if (k.length > 0) {
          this.getKeyts(k);
      }
      return k;
    },
    displaySize() {
      return this.$store.state.resize.w;
    },
    keytsLoaded() {
      return this.$store.getters.get_keytsLoaded;
    },
  },
  watch: {
    t: {
      handler: function(newData, oldData) {
          // console.log(newData)
          this.getKeyts(newData);
      },
      deep: true,
    },
    '$store.state.userData.passport_serial': {
      handler(serial) {
        if (serial && !this.kycChecked) {
          this.kycChecked = true;
          this.checkKycOnLogin();
        }
      },
      immediate: true,
    },
  },
  methods: {
    createKeytModal() {
      this.$store.commit('MODAL', {
        action: true,
        type: 'CreateKeyt',
        content: {
          title: this.$t('views.Home.39'),
        }
      });
    },
    paySelect(modalName) {
      if(modalName === 'deposit') {
        this.$store.commit('MODAL', {
          action: true,
          type: 'PaySelect',
          content: {
            title: this.$t('components.service.modal.PaySelect.32'),
            action: 'payIn',
            width: 608,
            curr: this.selected_curr
          }
        })
      } else if(modalName === 'withdraw') {
        this.$store.commit('MODAL', {
          action: true,
          type: 'PaySelect',
          content: {
            title: this.$t('components.service.modal.PaySelect.31'),
            action: 'payOut',
            width: 608,
            curr: this.selected_curr
          }
        })
      }
    },
    loki() {
      this.axios.post('dev_loki', {no_loader: true});
    },
    event_enter(el) {
      gsap.fromTo(el, { opacity: 0, width: 0 }, { opacity: 1, width: 'auto', duration: 0.4 });
    },
    event_leave(el, done) {
      gsap.fromTo(el, { opacity: 1 }, { opacity: 0.1, width: 0, duration: 0.4, onComplete: done });
    },
    payTemplate(arg) {
      if (arg.type == 'pay') {
        this.$router.push({name: 'Pay', query: {
                  template: arg.num
                }})
      }
      if (arg.type == 'tran') {
        this.$router.push({name: 'Transfer_id', query: {
                  template: arg.num,
                }})
      }
      if (arg.type == 'payin') {
        this.$router.push({name: 'Payin', query: {
                  template: arg.num,
                }})
      }
    },
    changeStage(arg) {
      this.of_stage = arg;
    },
    PayIn(arg) {
      let params = {
        keyt: arg,
      };
      this.$router.push({name: 'Payin', query: params})
    },
    payOperator(arg) {
      this.$router.push({name: 'Pay', query: {
                   operator: arg.code,
                   name: arg.name
                }})
    },
    getKeyts(k) {
        let arr = structuredClone(k);
        let s = structuredClone(this.$store.getters.get_currs_keyts_sum);
        // console.log('keyt_sum', s);
        // if (arr.length > 2) {
        //   this.keyts_length = arr.length;
        //   arr.splice(2, arr.length);
        // }
        let tmp = [];
        let tmp_currs = [];
        if (this.of_stage === 0) {
            tmp = arr;
            tmp_currs = s;
        } else {
            arr.forEach(e => {
                if (this.of_stage === 1 && e.fiat === '1') {
                    tmp.push(e);
                } else if (this.of_stage === 2 && e.fiat === '0') {
                    tmp.push(e)
                }
            });
            s.forEach(e => {
                if (this.of_stage === 1 && e.fiat === '1') {
                    tmp_currs.push(e);
                } else if (this.of_stage === 2 && e.fiat === '0') {
                    tmp_currs.push(e)
                }
            });
        }
        tmp.forEach(keyt => {
          keyt.usdRate = ''
          if(keyt.rate) {
            keyt.usdRate = this.$lib.precRound(this, this.$lib.ev(this, `${keyt.balance} * ${keyt.rate}`), '2');
          }
        })
        this.keyts_length = tmp.length;
        this.keyts = tmp;
        if (tmp_currs.length > 0) {
          let pref_curr = localStorage.getItem(this.storage_key);
          if (pref_curr !== null) {
            tmp_currs.forEach(e => {
              if (e.code == pref_curr) {
                this.selected_curr = e;
                this.selected_curr_key = e.code;
              }
            })
          }
          if ( !this.selected_curr ) {
            this.selected_curr = tmp_currs[0];
            this.selected_curr_key = tmp_currs[0]['code'];
            localStorage.setItem(this.storage_key, this.selected_curr_key);
          }
        }
        this.currs_keywords = tmp_currs;
    },
    getTemplates() {
      if (this.$store.state.userData.templates) {
        let cat = this.$store.state.userData.templates.catalog.slice(0);
        cat.forEach(e => {
          e.type = 'pay';
        });
        let tran = this.$store.state.userData.templates.transfer.slice(0);
        tran.forEach(e => {
          e.type = 'tran';
        });
        let payin = this.$store.state.userData.templates.payin.slice(0);
        payin.forEach(e => {
          e.type = 'payin';
        });
        this.templates_length = cat.length + tran.length + payin.length;
        if (cat.length > 2) {
          cat.splice(2, cat.length)
        }
        if (tran.length > 2) {
          tran.splice(2, tran.length)
        }
        if (payin.length > 2) {
          payin.splice(2, payin.length)
        }
        this.templates = cat.concat(tran, payin);
        // console.log(this.templates);
      } else {
        setTimeout(() => {
          this.getTemplates();
        }, 2000);
      }
    },
    updateState(arg) {
      // console.log(arg);
      // console.log(this.currs)
      this.selected_curr = false;
      this.selected_curr_key = arg.value;
      localStorage.setItem(this.storage_key, this.selected_curr_key);
      this.currs_keywords.forEach(e => {
        if (arg.value == e['code']) {
          this.selected_curr = e;
        }
      })
      this.getOverallBalance()
    },
    getOverallBalance() {
      if (!this.$store.state.config.KEYTS_RATE_CURR) {
        this.$store.commit("WARNING", {
          warningType: 'error',
          warningText: 'KEYTS_RATE_CURR not found in config',
        }); 
        return;
      }
      if( !this.selected_curr) {
        return;
      }
      this.getRate()
    },
    getRate() {
      this.overall_balance = false;
      this.rate = false;
      this.axios.post('GetRateConversion', {no_loader: true, data: {
        'currency_from': this.$store.state.config.KEYTS_RATE_CURR,
        'currency_to': this.selected_curr.curr_code,
      }}).then((res) => {
        if(res.data.body.tables?.rates?.colvalues[0]?.rate) {
          this.rate = res.data.body.tables.rates.colvalues[0].rate
          let sum = 0;
          this.currs_keywords.forEach(keyt => {
            if(keyt.rate) {
              sum += Number(this.convertByRate(keyt))
            }
            //console.log('keyt.curr_code', keyt.curr_code)
            //console.log('keyt.curr_code == this.selected_curr.curr_code', keyt.curr_code == this.selected_curr.curr_code)
            if(keyt.curr_code == this.selected_curr.curr_code) {
              sum += Number(this.convertByRate(keyt))
              // console.log('sum', sum)
            }
          })
          // console.log('sum', sum)
          this.overall_balance = Number(this.convertByRate({ balance: sum, rate: this.rate }))
          // console.log('overall_balance', this.overall_balance)
        } else {
          this.rate = false
        }
      })
    },
    copy(text) {
      this.$lib.copyTextS(text, this.$store)
    },
    convertByRate(arg) {
      return arg.rate ? this.$lib.precRound(this, this.$lib.ev(this, `${arg.balance} * ${arg.rate}`), this.selected_curr.precision) : 0
    },
    PayIn(arg) {
      let params = {
        keyt: arg,
      };
      this.$router.push({name: 'Payin', query: params})
    },
    sbstring(str) {
      if (str.length > 21) {
        return str.substring(0, 21) + '...';
      } else {
        return str;
      }
    },
    sumMask(sum) {
      let arr = sum.split('.');
      let classList = this.$store.state.resize.w <= 768 ? 'fsp20' : 'fsp32';
      let classList2 = this.$store.state.resize.w <= 768 ? 'fsp14' : 'fsp20';
      if (arr[1]) {
        return `<span class="${classList} first-part">${this.$lib.formatNumberWithSeparators(arr[0])}</span><span class='${classList2} primary-grey'>.${arr[1]}</span>`
      } else {
        return `<span class="${classList}">${this.$lib.formatNumberWithSeparators(arr[0])}</span>`
      }
    },
    checkKycOnLogin() {
      const serial = this.$store.state.userData.passport_serial;
      if (!serial || !serial.includes('MICA-Individual') || serial.includes('MICA-IndividualVerified')) return;

      // Show modal only if user hasn't dismissed it yet
      if (!localStorage.getItem('kyc_modal_dismissed')) {
        this.$store.commit('MODAL', {
          action: true,
          type: 'KycConfirm',
          content: {
            width: 608,
            onLater: () => {
              localStorage.setItem('kyc_modal_dismissed', '1');
              this.showKycBanner = true;
            },
          }
        });
      } else {
        this.showKycBanner = true;
      }
    },
    show_m(index) {
      this.news[index].show_m = !this.news[index].show_m;
    },
  },
}
</script>
<style lang="scss">
.menu-bg {
  color: $menu-bg
}
.mw-0 {
  min-width: 0;
}
.w30 {
    margin-right: 5%;
    @media (min-width: 661px) {
        width: 30% !important;
    }
    @media (max-width: 660px) {
        margin-right: 10%;
        width: 45% !important;
    }
    @media (max-width: 480px) {
        width: 100% !important;
    }
}
.w-150 {
  width: 150px !important;
}
.cell-btn {
  font-size: 16px; 
  overflow: hidden;
}
.create-btn {
  height: 48px;
  @media (max-width: 500px) {
    height: 40px;
  }
}
.individual_dep1 {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}
.pf-05 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.mb1r {
  margin-bottom: 1rem;
}
.h56 {
  height: 56px;
}
.k_table {
  .dep_3 {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
  tr{ 
    td {
      padding: 0.9rem 0.5rem;
    }
    td:nth-child(1) {
      padding-left: 0 !important;
      div {
        padding: 0.2rem;
        border-radius: 50%;
        color: white;
        font-size: 1.3rem;
        height: 39px;
        width: 39px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        span {
          height: 30px;
        }
      }
    }
    td:nth-child(2) {
      line-height: 1.1rem;
      padding-top: 1rem !important;
      padding-bottom: 0.8rem !important;
    }
    td:nth-child(3) {
      text-align: right;
      white-space: nowrap;
    }
    td:last-child {
      padding-right: 0 !important;
    }
  }
  tr:last-child {
    border: none;
    td {
      border: none;
    }
  }
}
.height_fix {
  min-height: 356px;

  @media (max-width: 768px) {
    min-height: 268px;
    height: auto;
  }
}
.confirm-pass {
  position: sticky;
  top: 54px;
  left: 0;
  z-index: 1999;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 100%;
    background-color: $primary-stroke;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}
.kyc-banner {
  background-color: $color-orange-light;
  border: 1px solid $dark-orange;
  border-left: 6px solid $dark-orange;
  border-radius: 8px;
  padding: 16px 24px;

  &__text {
    color: $dark-orange;
    font-size: 16px;
  }

  &__btn {
    display: flex;
    align-items: center;
    background-color: $dark-orange;
    color: #FFFFFF;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.2s;

    &:hover {
      background-color: $dark-orange-hover;
    }
  }
}
.text-link {
  position: relative;
  color: $menu-bg;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: $menu-bg;
  }
}

.curr-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
  }
}

  .individual_dep1 {
    @media (min-width: 992px) {
        justify-content: space-between;
    }
    .sub_dep_1 {
      @media (min-width: 992px) {
        width: 27%;
        .w30 {
          margin-right: 0 !important;
          width: 100% !important;
        }
      }
    }
    .sub_dep_2 {
      @media (min-width: 992px) {
        width: 70%;
      }
    }
  }  

@media (min-width: 661px) {
    .w30:nth-child(3n) {
        margin-right: 0 !important;
    }
}
@media (max-width: 660px) {
    .w30:nth-child(2n) {
        margin-right: 0 !important;
    }
}
@media (max-width: 480px) {
    .w30 {
        margin-right: 0 !important;
    }
}
.wh-37 {
  @media (min-width: 992px) {
      width: 32%;
  }
}
.wh-60 {
  @media (min-width: 992px) {
      width: 65%;
  }
}

.max-w-120 {
  flex: 1 0 120px;
}
</style>